import { toUpper } from 'lodash';
import { memo } from 'react';

import { type Clip } from '@air/api/types';
import { getFilename } from '@air/component-file-extension-preview';
import { formatBytes } from '@air/utilities';

import { GalleryFilePreviewIcon } from '~/components/v2/components/shared/gallery/GalleryFilePreviewIcon';

export type DndFileDragPreviewProps = {
  file: Clip;
};

export const DNDFileGalleryCardDragPreview = memo(({ file }: DndFileDragPreviewProps) => {
  const meta = [file.ext ? toUpper(file.ext) : null, file.size ? formatBytes(file.size) : null]
    .filter(Boolean)
    .join(' · ');

  return (
    <div className="relative size-full rounded-16 ads:bg-base bg-gray-1 shadow-drag-preview">
      <div className="absolute inset-1 flex flex-col justify-between overflow-hidden rounded-12 ads:bg-raised bg-gray-2">
        <div className="flex justify-between p-3">
          <GalleryFilePreviewIcon file={file} />
        </div>
        <div className="flex flex-col items-start gap-0.5 p-2">
          <span className="line-clamp-2 font-medium ads:text-primary text-16 text-gray-12">{getFilename(file)}</span>
          {!!meta && <span className="ads:text-metadata text-12 text-gray-10">{meta}</span>}
        </div>
      </div>
    </div>
  );
});

DNDFileGalleryCardDragPreview.displayName = 'DNDFileGalleryCardDragPreview';
